export default __webpack_public_path__ + "static/media/vki-nl.2f99ede9.pdf";